
import React, { Component } from 'react';
import { InfoBudgetContainer, InfoBudgetContainerContent } from './styles';

class InfoBudget extends Component {
    constructor(props){
        super(props)
    }
    render() {
        return (
            <InfoBudgetContainer>
                <InfoBudgetContainerContent>
                    <p>PEDIDO: <strong>{this.props.codigo_proposta}</strong> 01/11/2021 17:00:00</p>
                </InfoBudgetContainerContent>
                <button onClick={()=>this.props.backToBudget()}>Voltar pedido para orçamento?</button>
            </InfoBudgetContainer>
        );
    }
}

export default InfoBudget;